<template>
  <base-modal
    ref="core"
    :nested="false"
  >
    <template #header>
      <h4>{{ this.isEdit ? $t('geoFencingEvents.editItemHeadline') : $t('geoFencingEvents.addItemHeadline') }}</h4>
    </template>

    <template #body>
      <div
        class="form-horizontal"
        role="form"
      >
        <div class="form-body">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6">
                <label class="control-label">{{ $t('geoFencingEvents.vehicleRegistration') }}</label>
                <select
                  class="form-control input-sm"
                  v-model="v.geoFencingEvents.vehicleId.$model"
                  :class="{ 'custom-error': v.geoFencingEvents.vehicleId.$error }"
                >
                  <option
                    value=""
                    disabled
                    selected
                    hidden
                  >
                    {{ $t('geoFencingEvents.selectPlaceholder') }}
                  </option>
                  <option
                    :key="vehicle.id"
                    v-for="vehicle in vehicles"
                    :value="vehicle.id"
                  >
                    {{ vehicle.registration }}
                  </option>
                </select>
                <div
                  v-for="error of v.geoFencingEvents.vehicleId.$errors"
                  :key="error.$uid"
                  class="vuelidate-errors"
                >
                  <p class="error-msg">
                    {{ error.$message }}
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <label class="control-label">{{ $t('geoFencingEvents.geoFencingName') }}</label>
                <select
                  class="form-control input-sm"
                  v-model="v.geoFencingEvents.geofencingId.$model"
                  :class="{ 'custom-error': v.geoFencingEvents.geofencingId.$error }"
                >
                  <option
                    value=""
                    disabled
                    selected
                    hidden
                  >
                    {{ $t('geoFencingEvents.selectPlaceholder') }}
                  </option>
                  <option
                    :key="geofencing.id"
                    v-for="geofencing in geofencings"
                    :value="geofencing.id"
                  >
                    {{ geofencing.name }}
                  </option>
                </select>
                <div
                  v-for="error of v.geoFencingEvents.geofencingId.$errors"
                  :key="error.$uid"
                  class="vuelidate-errors"
                >
                  <p class="error-msg">
                    {{ error.$message }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-md-6 mt-5">
                <label class="control-label">{{ $t('geoFencingEvents.type') }}</label>
                <select
                  class="form-control input-sm"
                  v-model="v.geoFencingEvents.typeId.$model"
                  :class="{ 'custom-error': v.geoFencingEvents.typeId.$error }"
                >
                  <option
                    value=""
                    disabled
                    selected
                    hidden
                  >
                    {{ $t('geoFencingEvents.selectPlaceholder') }}
                  </option>
                  <option value="1">
                    {{ $t('geoFencingEvents.typeIn') }}
                  </option>
                  <option value="0">
                    {{ $t('geoFencingEvents.typeOut') }}
                  </option>
                </select>
                <div
                  v-for="error of v.geoFencingEvents.typeId.$errors"
                  :key="error.$uid"
                  class="vuelidate-errors"
                >
                  <p class="error-msg">
                    {{ error.$message }}
                  </p>
                </div>
              </div>
              <div class="col-md-6 mt-5">
                <label class="control-label">{{ $t('geoFencingEvents.state') }}</label>
                <select
                  class="form-control input-sm"
                  v-model="v.geoFencingEvents.stateId.$model"
                  :class="{ 'custom-error': v.geoFencingEvents.stateId.$error }"
                >
                  <option
                    value=""
                    disabled
                    selected
                    hidden
                  >
                    {{ $t('geoFencingEvents.selectPlaceholder') }}
                  </option>
                  <option value="1">
                    {{ $t('geoFencingEvents.stateActive') }}
                  </option>
                  <option value="0">
                    {{ $t('geoFencingEvents.stateDeactive') }}
                  </option>
                </select>
                <div
                  v-for="error of v.geoFencingEvents.stateId.$errors"
                  :key="error.$uid"
                  class="vuelidate-errors"
                >
                  <p class="error-msg">
                    {{ error.$message }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="pull-right">
        <button
          class="btn btn-default"
          @click="closeModal"
        >
          <i class="fa fa-remove" />
          {{ $t('components.vehicles.modals.exit') }}
        </button>
        <button
          class="btn btn-primary"
          @click="editGeoFencingEvents"
        >
          <i class="fa fa-save" />
          {{ $t('components.vehicles.modals.save') }}
        </button>
        <a
          v-if="isEdit"
          class="btn btn-danger float-right"
          @click="removeItem(this.geoFencingEvents.id)"
        >
          <i class="fa fa-remove" />{{ $t('components.sentGeo.dataGrids.delete') }}
        </a>
      </div>
    </template>
  </base-modal>
</template>

<script lang="ts">
import BaseModal from './core/BaseModal.vue'
import {defineComponent} from 'vue'
import useVuelidate from '@vuelidate/core'
import {required} from '@/vuelidate/i18n-validators'
import {getMyVehicles} from "@/crud/getters"
import {addGeofencingEvents, editGeofencingEvents} from "@/crud/geofencing/senders";
import {removeGeofencingEvent} from "@/crud/geofencing/removers";

function editGeoFencingEvents() {
  return {
    id: '',
    vehicleId: '',
    typeId: '',
    geofencingId: '',
    stateId: '',
    imei: ''
  }
}

export default defineComponent({
  name: 'GeoFencingEventsModal',
  components: {
    BaseModal,
  },
  props: [
    'items'
  ],
  data() {
    const self: any = this

    return {
      geoFencingEvents: editGeoFencingEvents(),
      vehicles: {},
      geofencings: this.items,
      isEdit: false,
    }
  },
  setup() {
    return {v: useVuelidate()}
  },
  validations: {
    geoFencingEvents: {
      vehicleId: {required},
      typeId: {required},
      geofencingId: {required},
      stateId: {required},
    }
  },
  watch: {
    isEdit(val) {
      const self: any = this
      if (!val) {
        self.geoFencingEvents = editGeoFencingEvents()
      }
    },
  },
  methods: {
    removeItem(id: number) {
      const self: any = this

      self.$swal.fire({
        title: self.$t('geofencing.removeQuestion'),
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonColor: '#d63043',
        confirmButtonText: self.$t('components.sentGeo.dataGrids.delete'),
        cancelButtonText: self.$t('geofencing.cancel'),
        target: '.custom_modal'
      }).then((result) => {

        if (result.isConfirmed) {
          removeGeofencingEvent(id).then(() => {
            self.$emit('emittedRefreshGrid', true)
            self.geoFencingEvents = editGeoFencingEvents()
            self.$toast.success(self.$t('geofencing.removed'));
          }).catch(() => {
            self.$toast.warning('ERROR !')
          })
        }

        self.$refs.core.closeModal()
      })

    },
    openEditModal(data) {
      const self: any = this

      if (data) {
        Object.assign(this.geoFencingEvents, JSON.parse(JSON.stringify(data)))
        self.isEdit = true
      } else {
        self.isEdit = false
      }
      self.getVehicles()

      this.v.$reset()
      self.$refs.core.openModal()
    },
    closeModal() {
      const self: any = this
      self.$refs.core.closeModal()
    },
    editGeoFencingEvents() {
      this.v.$touch()
      if (!this.v.$invalid) {
        const self: any = this

        let imeiValue = null;
        const selectedVehicle = self.vehicles.find(v => v.id === parseInt(self.geoFencingEvents.vehicleId));
        if (selectedVehicle && selectedVehicle.imei) {
          imeiValue = selectedVehicle.imei;
        }

        const postData = {
          vehicleId: parseInt(self.geoFencingEvents.vehicleId),
          geofencingId: parseInt(self.geoFencingEvents.geofencingId),
          stateId: parseInt(self.geoFencingEvents.stateId),
          typeId: parseInt(self.geoFencingEvents.typeId),
          imei: imeiValue
        };

        if (self.isEdit) {
          postData['id'] = parseInt(this.geoFencingEvents.id)

          editGeofencingEvents(postData).then(() => {
            self.$emit('emittedRefreshGrid', true)
            self.$toast.success(self.$t('geofencing.edited'));
            self.geoFencingEvents = editGeoFencingEvents()
          }).catch(() => {
            self.$toast.warning('ERROR !')
          })
        } else {
          addGeofencingEvents(postData).then(() => {
            self.$emit('emittedRefreshGrid', true)
            self.$toast.success(self.$t('geofencing.added'));
            self.geoFencingEvents = editGeoFencingEvents()
          }).catch(() => {
            self.$toast.warning('ERROR !')
          })
        }

        self.$refs.core.closeModal()
      }
    },
    getVehicles() {
      const self: any = this;
      self.vehicles = [];

      getMyVehicles().then((response: any) => {
        let imeiExists = false;

        response.data.forEach((vehicle) => {
          if (vehicle.device && vehicle.device.imei) {
            vehicle.imei = vehicle.device.imei;
            imeiExists = true;
          } else {
            vehicle.imei = null;
          }
          self.vehicles.push(vehicle);
        });

        if (!imeiExists) {
          console.error('Error: No IMEI available for any vehicle.');
        }
      });
    },
  }
})
</script>